import Home from "./pages/home";
import Default from "./default-page";
import radio from "./radio";
import { ajax } from "./utils";

class Router {
  constructor(app) {
    this.app = app;
    this.fetchingCount = 0;

    window.addEventListener("popstate", (e) => {
      // Makes sure the correct page is viewed
      window.location.reload();
    });

    const mainElement = document.querySelector(".page-content");
    this.initPage(mainElement);
  }

  initPage(mainElement) {
    const pageName = mainElement.dataset.page;

    const ClassPage = (() => {
      if (pageName == "home") {
        return Home;
      } else {
        return Default;
      }
    })();

    this.currentPage = new ClassPage({ el: mainElement });
    this.currentPage.render();
    this.app.responsiveFactory.init();
    const hash = window.location.hash.replace("#", "");
    const hashTarget = document.getElementById(hash);
    if (hashTarget) {
      const y = hashTarget.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, y);
    }
  }

  fetchPage(href) {
    window.history.pushState({}, {}, href);
    this.currentPage.trigger("animateout");
    radio.trigger("animateout");

    this.fetchingCount += 1;

    ajax({
      url: href,
      method: "GET",
    })
      .then((result) => {
        this.fetchingCount -= 1;
        if (this.fetchingCount > 0) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(result, "text/html");
        const newPage = doc.querySelector(".page-content");

        newPage.style.opacity = 1;
        this.app.ui.wrapper.appendChild(newPage);
        this.initPage(newPage);
        this.currentPage.animateIn({});
        document.title = doc.title;
        document.body.dataset.page = newPage.dataset.page;
        document.body.dataset.template = newPage.dataset.template;
        document.getElementById("lang").innerHTML =
          doc.getElementById("lang").innerHTML;
      })
      .catch(() => {
        window.location.href == href;
      });
  }
}
export default Router;
